export default __webpack_public_path__ + "810ee33cd8f236ba126cc7ae1d94d5a1.png";